import React from "react"
import * as api from "brandguard/api"
import GenerateCorrectionShared from "brandguard/components/generate.correction"

interface props {
	items: api.ImageSearchResponseItem[]
	onCorrectionComplete?: () => void
}

export default function GenerateCorrection(props: props): JSX.Element {
	return <GenerateCorrectionShared items={props.items} corrections={api.images.corrections} progressLabel="image" onCorrectionComplete={props.onCorrectionComplete} />
}
